export default __webpack_public_path__ + "static/media/iitb.664d1971.png";